// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Locations_tableDiv__jTsH3 {
  margin-top: 24px;
}

.Locations_btnClass__jDRSD {
  min-width: 160px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Locations/Locations.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".tableDiv {\n  margin-top: 24px;\n}\n\n.btnClass {\n  min-width: 160px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableDiv": `Locations_tableDiv__jTsH3`,
	"btnClass": `Locations_btnClass__jDRSD`
};
export default ___CSS_LOADER_EXPORT___;
